var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = require("@/static/personalCenter/nostrategy.png")

  var m1 = require("@/static/personalCenter/soundWall-message.png")

  var m4 = require("@/static/service/map_loc.png")

  var l1 = _vm.__map(_vm.mySoundWallList, function(item, index) {
    var m2 = _vm.chatSum(item.comments)

    var l0 = _vm.__map(item.images, function(tt, ii) {
      var m3 = _vm.$getImg(tt)
      return {
        $orig: _vm.__get_orig(tt),
        m3: m3
      }
    })

    return {
      $orig: _vm.__get_orig(item),
      m2: m2,
      l0: l0
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m4: m4,
        l1: l1
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }